// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyD08z_XCnwjgOglqPEqO0DmVCe_HKUNGxE",
    authDomain: "glamyocrm.firebaseapp.com",
    projectId: "glamyocrm",
    storageBucket: "glamyocrm.appspot.com",
    messagingSenderId: "1068310350384",
    appId: "1:1068310350384:web:d26d19b20b2e5559467bf5",
    measurementId: "G-DVV7121G9N"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
